import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Contact from '../components/Contact';

export default function Portfolio() {
  return (
    <div className="bg-zinc-950 min-h-screen text-zinc-400 font-sans selection:bg-zinc-700 selection:text-white">
      <div className="mx-auto min-h-screen max-w-screen-xl px-6 py-12 md:px-12 md:py-20 lg:px-24 lg:py-0">
        <div className="lg:flex lg:justify-between lg:gap-4">
          
          {/* Left fixed pane */}
          <header className="lg:sticky lg:top-0 lg:flex lg:max-h-screen lg:w-[45%] lg:flex-col lg:justify-between lg:py-24">
            <div>
              <Hero />
              <Navigation />
            </div>
          </header>

          {/* Right scrollable pane */}
          <main id="content" className="pt-24 lg:w-[50%] lg:py-24 flex flex-col gap-24">
            <About />
            <Skills />
            <Projects />
            <Contact />
            
            <footer className="text-sm text-zinc-500 mt-24 mb-12">
              <p>
                © 2024 <span className="text-zinc-200 font-medium">Jia De (Arthur) Pang</span>. All rights reserved.
              </p>
              <p className="mt-1">
                Crafted with intention and precision. Built with React & Tailwind CSS.
              </p>
            </footer>
          </main>
          
        </div>
      </div>
    </div>
  );
}